import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
export const ContextualPlaceholder = Extension.create({
    name: 'contextualPlaceholder',
    addOptions() {
        return {
            placeholder: 'Type / for commands...',
            includeChildren: false,
            showOnlyWhenEditable: true,
            showOnlyCurrent: true,
            emptyNodeClass: 'is-contextual-empty',
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: ['paragraph'],
                attributes: {
                    class: {
                        default: null,
                        rendered: false,
                    },
                },
            },
        ];
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('contextualPlaceholder'),
                props: {
                    decorations: ({ doc, selection }) => {
                        const active = this.editor.isEditable || !this.options.showOnlyWhenEditable;
                        const { anchor } = selection;
                        const decorations = [];
                        if (!active) {
                            return null;
                        }
                        doc.descendants((node, pos) => {
                            const hasAnchor = anchor >= pos && anchor <= pos + node.nodeSize;
                            const isEmpty = !node.isLeaf && !node.childCount;
                            // Only show contextual placeholder for empty paragraphs that come after images
                            if ((hasAnchor || !this.options.showOnlyCurrent) && isEmpty && node.type.name === 'paragraph') {
                                const $pos = doc.resolve(pos);
                                const prevNode = $pos.nodeBefore;
                                // Only add contextual placeholder if this paragraph comes after an image
                                if (prevNode && prevNode.type.name === 'image') {
                                    const decoration = Decoration.node(pos, pos + node.nodeSize, {
                                        class: this.options.emptyNodeClass,
                                        'data-placeholder': this.options.placeholder,
                                    });
                                    decorations.push(decoration);
                                }
                            }
                            return false;
                        });
                        return DecorationSet.create(doc, decorations);
                    },
                },
            }),
        ];
    },
    addGlobalStyles() {
        return `
      .ProseMirror .is-contextual-empty::before {
        content: attr(data-placeholder);
        float: left;
        color: #9ca3af;
        pointer-events: none;
        height: 0;
        font-style: italic;
      }
      
      .dark .ProseMirror .is-contextual-empty::before {
        color: #6b7280;
      }
    `;
    },
});
//# sourceMappingURL=ContextualPlaceholder.js.map